import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import {
    INBOX_LIST_LOADING,
    SET_ASSIGN_MODAL,
    SET_AGENT_LIST,
    SET_PRIORITY_OPTION,
    SET_MESSAGE_TYPE_OPTION,
    SET_STATUS_OPTION,
    SET_AGENT_OPTION,
    SET_OFFSET_VALUE,
    TOGGLE_FILTER_COLUMN,
    SET_FILTERS,
    SET_SELECTED_AGENT_OPTIONS,
    SET_SORT_OPTION,
    FETCH_CXM_PAGES_LIST,
    TOGGLE_AUTO_ASSIGN,
    FETCH_AUTO_ASSIGN,
    SET_SELECTED_PAGES,
    //
    SET_CURRENT_POST,
    FETCH_COMMENTS_THREAD,
    TOGGLE_AUTO_RESPONSE,
    FETCH_AUTO_RESPONSE,
    FETCH_AUTO_RESPONSE_LIST,
    RESPONSE_MODE,
    UPDATE_USER_STATUS_INBOX,
    ASSIGN_AGENT,
    FETCH_MSG_COUNT,
    SET_AGENT_ACCESSABLE_PAGES,
    PAGE_TOKEN_LIST,
    SET_DEFAULT_LANGUAGE,
    TOGGLE_SURVEY,
    SET_USER_LIST,
    SET_PAGE_REACTION_LIST,
    UPDATE_PAGE_REACTION_LIST,
    SET_HAS_REACTIONS,
} from "../actions/socialResponseActions";
import _ from "lodash";

let initialState = {
    requireResponseListLoading: false,
    requireResponseList: [],
    openAssignModal: false,
    statusList: [],
    sfStatusList: [],
    agentListValue: {},
    agentListLoading: false,

    userListValue: [], // TAGS
    userListObj: {},
    userListLoading: false, // TAGS
    userListAfterCursor: "", // TAGS
    userListBeforeCursor: "", // TAGS

    currentUser: null,
    teamsListValue: {},
    userTeams: {},
    pageTeams: {},
    pageUsers: {},
    teamsListLoading: false,
    AuthenticationList: [],

    commentsList: [],

    priorityOption: ["selectAll"],
    messageTypeOption: ["selectAll"],
    statusOption: ["selectAll"],
    agentOption: [],
    selectedAgentOption: [], // cleanup
    selectedPageOption: ["selectAll"],
    offsetValue: 0,
    totalPostsCount: null,

    filterUpdated: 0,

    filtersExpanded: false,
    filters: {
        // duration: "30",
        creationDuration: "30", //all
        updateDuration: "30",
        entitySubType: "all",
        entityType: "all",
    },
    responseModeVal: "Custom",

    filterRefineFilter: {
        sentiment: ["all"],
        exclusion: "yes",
        messageTypeOption: ["selectAll"],
        statusOption: ["selectAll"],
        priorityOption: ["selectAll"],
        tagsOption: ["selectAll"],
        sfOption: "selectAll",
        ratingsOption: ["selectAll"],
        spamOptions: "0",
        keywordOption: [],
    },
    custom_query: "",
    statusGroup: false,

    sortOption: "post_updated_at",
    syncSortOption: "all",
    userStatusInbox: "",
    smrPagesList: {},
    smrPagesListLoading: false,
    statusUpdate: false,
    autoAssignFlag: false,
    autoAssignStatus: false,
    autoAssignOnlineUser: false,
    autoLogoutPeriodInMin: 15,
    isAllTopicChecked: false,
    autoResponseStatus: false,
    autoResponseList: {},
    surveyStatus: false,
    surveyColor: "#fff",
    surveyPageIds: "",

    currentSelectedPost: null,
    scrollToCurrentPost: false,
    postConversationsData: {},
    postConversationsDataLoading: {},
    postConversationsDataError: {},
    postTicketHistory: {},
    postTicketHistoryLoading: {},
    postTicketHistoryError: {},
    socialUserInfo: {},
    socialUserInfoLoading: {},
    socialUserInfoError: {},
    selectedPosts: [],

    smrNotifications: [],

    smrTags: {},
    smrTagsLoading: false,
    msgStats: null,
    insightsToken: {},
    defaultLanguages: [],
    queuedTicketId: null,
    ticketCount: 0,
    smrKeywords: [],
    smrKeywordsLoading: false,

    /**
     * @structure
     * pageReactions: {
     *     [message_es_id]: {
     *        pageReactionList: [],
     *        hasReactions: false,
     *     }
     * }
     */
    pageReactions: {},
};

const socialResponseReducer = (state = initialState, action) => {
    switch (action.type) {
        case isPending(INBOX_LIST_LOADING):
            return (state = {
                ...state,
                requireResponseListLoading: true,
                requireResponseList: [],
                totalPostsCount: 0,
            });
        case isRejected(INBOX_LIST_LOADING):
            return (state = {
                ...state,
                requireResponseListLoading: false,
                requireResponseList: [],
                totalPostsCount: 0,
            });
        case isFulfilled(INBOX_LIST_LOADING): {
            // const posts = action.payload?.data?.tickets;
            // const filteredPosts = action.payload?.data?.tickets.filter((obj) => obj.is_deleted !== 1); // remove deleted posts

            return (state = {
                ...state,
                requireResponseListLoading: false,
                requireResponseList:
                    action.payload?.data?.tickets ||
                    // .sort((a, b) => {
                    //     if (a.created_date > b.created_date) return -1;
                    //     else return 1;
                    // })
                    [],
                totalPostsCount: action.payload?.data?.total || 0,
            });
        }

        case isFulfilled("SMR_STATUS_LIST"): {
            return (state = {
                ...state,

                statusList: action.payload || [],
            });
        }

        case isFulfilled("SMR_SF_STATUS_LIST"): {
            return (state = {
                ...state,

                sfStatusList: action.payload || [],
            });
        }

        case isFulfilled("CONFIG_SF_LIST"): {
            return (state = {
                ...state,

                AuthenticationList: action.payload || [],
            });
        }
        case SET_ASSIGN_MODAL:
            return (state = {
                ...state,
                openAssignModal: action.payload,
            });

        case isPending(SET_AGENT_LIST):
            return (state = {
                ...state,
                agentListLoading: true,
                agentListValue: {},
            });
        case isRejected(SET_AGENT_LIST):
            return (state = { ...state, agentListLoading: false, agentListValue: {} });

        case isFulfilled(SET_AGENT_LIST): {
            let agentListValue = {};
            let currentUser = null;

            if (action.payload.data.users) {
                action.payload.data.users.forEach((user) => {
                    agentListValue[user.lite_id] = user;
                    if (action.payload.loggedInUser === user.id) currentUser = user;
                });
            }

            let agentOption = [];
            if (!currentUser.roles.includes("cxm")) agentOption = [currentUser.lite_id];
            return { ...state, agentListLoading: false, agentListValue, currentUser, agentOption };
        }

        case isPending(SET_USER_LIST):
            // console.log("PENDING--userlist");
            /*
             * loadMore is true in case of facebook
             */
            if (action.payload.loadMore)
                return (state = {
                    ...state,
                    userListLoading: true,
                    userListValue: [...state.userListValue],
                });
            return (state = {
                ...state,
                userListLoading: true,
                userListValue: [],
            });

        case isRejected(SET_USER_LIST):
            return (state = { ...state, userListLoading: false, userListValue: [] });

        case isFulfilled(SET_USER_LIST):
            // console.log("[ACTION_PAYLOAD]", action.payload);
            if (!action.payload.data) {
                // console.log("CANCEL_REQUEST");
                return (state = { ...state, userListLoading: true, userListValue: [] });
            } else {
                // let userListObj = {}; // not required as of now
                if (action.payload.platform === "x") {
                    return (state = {
                        ...state,
                        userListLoading: false,
                        userListValue: action.payload.data.user_lists,
                    });
                }

                // action.payload.data.data.user_lists.map((user) => {
                //     userListObj[user.id] = user;
                // }); // not required as of now
                if (action.payload.platform === "facebook") {
                    // keyCode : 8 is for backspace
                    if (action.payload.keyCode === 8) {
                        return (state = {
                            ...state,
                            userListLoading: false,
                            userListValue: action.payload.data.user_list,
                            userListAfterCursor: action.payload.data.after,
                            userListBeforeCursor: action.payload.data.before,
                        });
                    }
                }

                return (state = {
                    ...state,
                    userListLoading: false,
                    userListValue: [...state.userListValue, ...action.payload.data.user_list],
                    userListAfterCursor: action.payload.data.after,
                    userListBeforeCursor: action.payload.data.before,
                });
            }

        case isPending("SET_SMR_TEAMS_LIST"):
            return (state = { ...state, teamsListLoading: true, teamsListValue: {} });

        case isRejected("SET_SMR_TEAMS_LIST"):
            return (state = { ...state, teamsListLoading: false, teamsListValue: {} });

        case isFulfilled("SET_SMR_TEAMS_LIST"): {
            let teamsListValue = {};
            let userTeams = {};
            let pageTeams = {};
            let pageUsers = {};
            if (action.payload.teams) {
                action.payload.teams.forEach((team) => {
                    teamsListValue[team.id] = team;

                    let usersList = team.users.map((user) => user.user_id);

                    team.pages.forEach((page) => {
                        if (pageTeams[page.page_id]) pageTeams[page.page_id].push(team.id);
                        else pageTeams[page.page_id] = [team.id];

                        if (pageUsers[page.page_id]) pageUsers[page.page_id].push(...JSON.parse(JSON.stringify(usersList)));
                        else pageUsers[page.page_id] = JSON.parse(JSON.stringify(usersList));
                    });

                    team.users.forEach((user) => {
                        if (userTeams[user.user_id]) userTeams[user.user_id].push(team.id);
                        else userTeams[user.user_id] = [team.id];
                    });
                });
            }

            Object.entries(pageUsers).forEach(([k, v]) => {
                pageUsers[k] = _.uniq(v);
            });

            return { ...state, teamsListLoading: false, teamsListValue, userTeams, pageTeams, pageUsers };
        }
        case isFulfilled("DELETE_SMR_TEAM"): {
            if (action.payload?.id) {
                let teamsListValue = JSON.parse(JSON.stringify(state.teamsListValue));
                delete teamsListValue[action.payload.id];

                return { ...state, teamsListValue };
            } else return state;
        }

        case SET_PRIORITY_OPTION:
            return (state = {
                ...state,
                priorityOption: action.payload,
            });
        case SET_MESSAGE_TYPE_OPTION:
            return (state = {
                ...state,
                messageTypeOption: action.payload,
            });
        case SET_STATUS_OPTION:
            return (state = {
                ...state,
                statusOption: action.payload,
            });
        case SET_AGENT_OPTION:
            return (state = {
                ...state,
                agentOption: action.payload,
                filterUpdated: state.filterUpdated + 1,
            });

        case SET_OFFSET_VALUE:
            return (state = {
                ...state,
                offsetValue: action.payload,
                filterUpdated: state.filterUpdated + 1,
            });

        case TOGGLE_FILTER_COLUMN:
            return (state = {
                ...state,
                filtersExpanded: action.payload,
            });
        case SET_FILTERS:
            return (state = {
                ...state,
                filters: action.payload.filters,
                filterRefineFilter: action.payload.filterRefineFilter,
                filterUpdated: state.filterUpdated + 1,
            });

        case SET_SELECTED_AGENT_OPTIONS:
            return (state = {
                ...state,
                selectedAgentOption: action.payload,
            });
        case SET_SORT_OPTION:
            return (state = {
                ...state,
                sortOption: action.payload,
                filterUpdated: state.filterUpdated + 1,
            });

        case "SET_SYNC_SORT_OPTION":
            return (state = {
                ...state,
                syncSortOption: action.payload,
                filterUpdated: state.filterUpdated + 1,
            });

        case isFulfilled(ASSIGN_AGENT):
            return (state = {
                ...state,
                filterUpdated: state.filterUpdated + 1,
            });

        case isFulfilled(UPDATE_USER_STATUS_INBOX):
            return (state = {
                ...state,
                userStatusInbox: action.payload.data.user.active_status,
                // filterUpdated: state.filterUpdated + 1,
            });
        case isPending(FETCH_CXM_PAGES_LIST):
            return (state = {
                ...state,
                smrPagesListLoading: true,
                smrPagesList: {},
            });
        case isRejected(FETCH_CXM_PAGES_LIST):
            return (state = {
                ...state,
                smrPagesListLoading: false,
                smrPagesList: {},
            });
        case isFulfilled(FETCH_CXM_PAGES_LIST): {
            let smrPagesList = {};
            action.payload.data?.tokens
                ?.filter((p) => p.features.includes("smr"))
                .forEach((p) => {
                    smrPagesList[p.page_id] = p;
                });
            return (state = {
                ...state,
                smrPagesListLoading: false,
                smrPagesList: smrPagesList,
            });
        }
        case SET_AGENT_ACCESSABLE_PAGES: {
            let smrPagesList = {};
            action.payload?.forEach((obj) => {
                smrPagesList[obj?.page_id] = obj;
            });
            return { ...state, smrPagesList: smrPagesList };
        }

        case isFulfilled(FETCH_AUTO_ASSIGN):
            return (state = {
                ...state,
                autoAssignStatus: action.payload.data.settings?.auto_assign_enabled === 1 ? true : false,
                autoResponseStatus: action.payload.data.settings?.auto_response_enabled === 1 ? true : false,
                autoResponseList: action.payload.data.settings,
                autoAssignOnlineUser: action.payload.data.settings?.auto_assign_to_online_user === 1 ? true : false,
                autoLogoutPeriodInMin: action.payload.data.settings?.auto_logout_period_min,
                surveyStatus: action.payload.data.settings?.survey_enabled === 1 ? true : false,
                surveyPageIds: action.payload.data.settings?.survey_page_ids,
                surveyColor: action.payload.data.settings?.survey_color,
            });
        case isFulfilled(TOGGLE_AUTO_ASSIGN):
            return (state = {
                ...state,
                autoAssignStatus: action.payload?.auto_assign_enabled === 1 ? true : false,
                autoAssignOnlineUser: action.payload?.auto_assign_to_online_user === 1 ? true : false,
                autoLogoutPeriodInMin: action.payload.auto_logout_period_min,
            });

        case RESPONSE_MODE:
            return (state = {
                ...state,
                responseModeVal: action.payload,
            });

        // case isFulfilled(FETCH_AUTO_RESPONSE):
        //     return (state = {
        //         ...state,
        //
        //         //autoResponseStatus: action.payload.data.settings.auto_assign_enabled === 1 ? true : false,
        //     });

        case isFulfilled(TOGGLE_AUTO_RESPONSE):
            return (state = {
                ...state,
                autoResponseStatus: !state.autoResponseStatus,
            });

        case isFulfilled("ESCALATION_SMR_TICKET"):
            return (state = {
                ...state,
                filterUpdated: state.filterUpdated + 1,
            });

        case isFulfilled(TOGGLE_SURVEY):
            if (action.payload.params.survey_enabled == 0 || action.payload.params.survey_enabled == 1) {
                return (state = {
                    ...state,
                    surveyStatus: !state.surveyStatus,
                });
            } else {
                return (state = {
                    ...state,
                    surveyStatus: state.surveyStatus,
                });
            }

        case isFulfilled(FETCH_AUTO_RESPONSE_LIST):
            return (state = {
                ...state,
                autoResponseList: action.payload,
            });

        case SET_SELECTED_PAGES:
            return (state = {
                ...state,
                selectedPageOption: action.payload,
                filterUpdated: state.filterUpdated + 1,
            });

        case SET_CURRENT_POST:
            return { ...state, currentSelectedPost: action.payload, scrollToCurrentPost: action.scrollToCurrentPost };
        case "SET_SCROLL_TO_POST":
            return { ...state, scrollToCurrentPost: action.payload };

        case isPending(FETCH_COMMENTS_THREAD): {
            const { postConversationsDataLoading, postConversationsDataError } = state;

            postConversationsDataLoading[action.convID] = true;
            postConversationsDataError[action.convID] = null;

            return { ...state, postConversationsDataLoading, postConversationsDataError };
        }

        case isFulfilled(FETCH_COMMENTS_THREAD): {
            const { postConversationsData, postConversationsDataLoading, postConversationsDataError } = state;

            postConversationsData[action.convID] = { ...action.payload, posts: action.payload.posts.reverse() };
            postConversationsDataLoading[action.convID] = false;
            postConversationsDataError[action.convID] = null;

            return { ...state, postConversationsData, postConversationsDataLoading, postConversationsDataError };
        }

        case isPending("FETCH_TICKET_HISTORY"): {
            const { postTicketHistoryLoading, postTicketHistoryError } = state;

            postTicketHistoryLoading[action.convID] = true;
            postTicketHistoryError[action.convID] = null;

            return { ...state, postTicketHistoryLoading, postTicketHistoryError };
        }

        case isFulfilled("FETCH_TICKET_HISTORY"): {
            const { postTicketHistory, postTicketHistoryLoading, postTicketHistoryError } = state;

            postTicketHistory[action.convID] = action.payload;
            postTicketHistoryLoading[action.convID] = false;
            postTicketHistoryError[action.convID] = null;

            return { ...state, postTicketHistory, postTicketHistoryLoading, postTicketHistoryError };
        }

        case isPending("GET_SOCIAL_USER_INFO"): {
            const { socialUserInfoLoading, socialUserInfoError } = state;

            socialUserInfoLoading[action.userId] = true;
            socialUserInfoError[action.userId] = null;

            return { ...state, socialUserInfoLoading, socialUserInfoError };
        }

        case isFulfilled("GET_SOCIAL_USER_INFO"): {
            const { socialUserInfo, socialUserInfoLoading, socialUserInfoError } = state;

            socialUserInfo[action.userId] = action.payload;
            socialUserInfoLoading[action.userId] = false;
            socialUserInfoError[action.userId] = null;

            return { ...state, socialUserInfo, socialUserInfoLoading, socialUserInfoError };
        }

        case "SET_CUSTOM_QUERY":
            return { ...state, custom_query: action.payload, filterUpdated: state.filterUpdated + 1 };

        case "UPDATE_POST": {
            let postIndex = state.requireResponseList.findIndex((p) => p?.es_id === action.payload?.es_id);

            let requireResponseList = JSON.parse(JSON.stringify(state.requireResponseList));
            requireResponseList[postIndex] = action.payload;

            return { ...state, requireResponseList };
        }
        case "UPDATE_POST_SF_SYNC": {
            let postIndex = state.requireResponseList.findIndex((p) => p?.es_id === action.payload?.[0].es_id);
            let requireResponseList = JSON.parse(JSON.stringify(state.requireResponseList));
            let currentSelectedPost = JSON.parse(JSON.stringify(state.currentSelectedPost));

            requireResponseList[postIndex].pushed_to_salesforce = 1;
            requireResponseList[postIndex].salesforce_sync_status = action.payload[0]?.salesforce_sync_status;
            if (currentSelectedPost != null) {
                currentSelectedPost.salesforce_sync_status = action.payload && action.payload[0]?.salesforce_sync_status;
            }

            return { ...state, requireResponseList, currentSelectedPost };
        }
        case "UPDATE_TICKET_MESSAGE": {
            let postIndex = state.postConversationsData[state.currentSelectedPost.response.ticket_id].posts.findIndex((p) => p.es_id === action.payload.es_id);

            let postConversationsData = state.postConversationsData;
            postConversationsData[state.currentSelectedPost.response.ticket_id] = JSON.parse(
                JSON.stringify(postConversationsData[state.currentSelectedPost.response.ticket_id]),
            );

            postConversationsData[state.currentSelectedPost.response.ticket_id].posts[postIndex] = action.payload;

            return { ...state, postConversationsData };
        }

        case "SELECTED_POSTS":
            return { ...state, selectedPosts: action.payload };

        case "UPDATE_FILTER_UPDATED":
            return { ...state, filterUpdated: state.filterUpdated + 1 };
        case "SMR_VIEW_TICKETS_SET_FILTERS": {
            let { filters, filterRefineFilter, extraFilters, sortOption, syncSortOption } = action.payload;

            let { priorityOption, messageTypeOption, statusOption, agentOption, selectedPageOption, custom_query, statusGroup } = extraFilters;

            filterRefineFilter.statusOption = statusOption;
            return {
                ...state,
                filters,
                filterRefineFilter,
                sortOption,
                agentOption,
                selectedPageOption,
                custom_query,
                statusGroup,
                syncSortOption,
            };
        }

        case isFulfilled("SET_SMR_NOTIFICATIONS_LIST"): {
            return { ...state, smrNotifications: action.payload.data };
        }

        case isPending("FETCH_TAGS_LIST"):
            return { ...state, smrTagsLoading: true };

        case isFulfilled("FETCH_TAGS_LIST"): {
            const smrTags = {};

            if (Array.isArray(action.payload))
                action.payload?.forEach((tag) => {
                    smrTags[tag.name] = tag;
                });

            return { ...state, smrTagsLoading: false, smrTags };
        }
        case isPending(FETCH_MSG_COUNT):
            return { ...state, msgStats: null };

        case isRejected(FETCH_MSG_COUNT):
            return { ...state, msgStats: null };

        case isFulfilled(FETCH_MSG_COUNT): {
            return { ...state, msgStats: action.payload?.analytics };
        }

        case isFulfilled(PAGE_TOKEN_LIST):
            return { ...state, insightsToken: action.payload };

        case isPending(SET_DEFAULT_LANGUAGE):
            return (state = { ...state, defaultLanguages: [] });

        case isFulfilled(SET_DEFAULT_LANGUAGE):
            return { ...state, defaultLanguages: action.payload?.language_codes || [] };

        case isRejected(SET_DEFAULT_LANGUAGE):
            return (state = { ...state, defaultLanguages: [] });

        case "SMR_QUEUE_TASK_COMPLETE":
            return { ...state, queuedTicketId: action.payload || null };

        case isFulfilled("INDIVIDUAL_TICKET_UPDATE"): {
            const ticket = action.payload?.tickets?.[0];
            // console.log("ticket", ticket?.es_id);
            if (ticket) {
                const postIndex = state.requireResponseList?.findIndex((p) => p?.es_id === ticket?.es_id);
                const requireResponseList = JSON.parse(JSON.stringify(state.requireResponseList));
                if (postIndex > -1) requireResponseList[postIndex] = ticket;

                return { ...state, requireResponseList };
            }
            return { ...state };
        }

        case "UPDATE_TICKET_COUNT": {
            return { ...state, ticketCount: action.payload };
        }

        case isPending("FETCH_KEYWORD_LISTS"):
            return { ...state, smrKeywordsLoading: true };

        case isFulfilled("FETCH_KEYWORD_LISTS"): {
            const smrKeywords = [];

            if (Array.isArray(action.payload)) {
                action.payload?.forEach((obj) => {
                    if (obj.is_deleted !== 1) {
                        smrKeywords.push({
                            ...obj,
                            rule: JSON.parse(obj.rule),
                        });
                    }
                });
            }

            return { ...state, smrKeywordsLoading: false, smrKeywords };
        }

        case "SMR_CLEANUP": {
            return initialState;
        }

        case SET_PAGE_REACTION_LIST:
            return {
                ...state,
                pageReactions: {
                    ...state.pageReactions,
                    [action.payload.message_es_id]: { pageReactionList: action.payload.pages, hasReactions: action.payload.pages.some((page) => page.reacted) },
                },
            };

        case UPDATE_PAGE_REACTION_LIST: {
            const { page_id, reacted, message_es_id } = action.payload;

            const pageReactionList = state.pageReactions[message_es_id].pageReactionList.map((page) => {
                if (page.page_id === page_id) page.reacted = !reacted;
                return page;
            });

            return {
                ...state,
                pageReactions: {
                    ...state.pageReactions,
                    [message_es_id]: { pageReactionList, hasReactions: pageReactionList.some((page) => page.reacted) },
                },
            };
        }

        case SET_HAS_REACTIONS: {
            const { reacted, message_es_id } = action.payload;

            return {
                ...state,
                pageReactions: {
                    ...state.pageReactions,
                    [message_es_id]: { ...state.pageReactions[message_es_id], hasReactions: reacted },
                },
            };
        }
        default:
            return state;
    }
};

export default socialResponseReducer;
